import React, { useEffect, useRef, useState } from "react";

// Só monta o widget quando ele chega perto da área visível (PO1-3439). Cada widget
// busca os próprios dados ao montar; assim o que está mais abaixo no painel só
// consulta quando o usuário rola até ele. Sem IntersectionObserver, monta direto.
export default function MontagemPreguicosa({ children }) {
  const ref = useRef(null);
  const [visivel, setVisivel] = useState(
    typeof window === "undefined" || typeof window.IntersectionObserver !== "function"
  );

  useEffect(() => {
    if (visivel || !ref.current) return undefined;
    const observer = new window.IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setVisivel(true);
          observer.disconnect();
        }
      },
      { rootMargin: "300px" }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [visivel]);

  if (visivel) return <>{children}</>;
  return <div ref={ref} className="meu-painel-placeholder" aria-hidden="true" />;
}
